import React from 'react';
import { IconProps } from './types';

export const WifiOnline: React.FC<IconProps> = props => {
  const { className, size = 18, fillColor = '#00952A', onClick } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 15.75C8.475 15.75 8.03125 15.5687 7.66875 15.2062C7.30625 14.8437 7.125 14.4 7.125 13.875C7.125 13.35 7.30625 12.9063 7.66875 12.5438C8.03125 12.1813 8.475 12 9 12C9.525 12 9.96875 12.1813 10.3313 12.5438C10.6938 12.9063 10.875 13.35 10.875 13.875C10.875 14.4 10.6938 14.8437 10.3313 15.2062C9.96875 15.5687 9.525 15.75 9 15.75ZM4.7625 11.5125L3.1875 9.9C3.925 9.1625 4.79063 8.57813 5.78438 8.14688C6.77813 7.71563 7.85 7.5 9 7.5C10.15 7.5 11.2219 7.71875 12.2156 8.15625C13.2094 8.59375 14.075 9.1875 14.8125 9.9375L13.2375 11.5125C12.6875 10.9625 12.05 10.5312 11.325 10.2188C10.6 9.90625 9.825 9.75 9 9.75C8.175 9.75 7.4 9.90625 6.675 10.2188C5.95 10.5312 5.3125 10.9625 4.7625 11.5125ZM1.575 8.325L0 6.75C1.15 5.575 2.49375 4.65625 4.03125 3.99375C5.56875 3.33125 7.225 3 9 3C10.775 3 12.4313 3.33125 13.9688 3.99375C15.5062 4.65625 16.85 5.575 18 6.75L16.425 8.325C15.4625 7.3625 14.3469 6.60938 13.0781 6.06563C11.8094 5.52188 10.45 5.25 9 5.25C7.55 5.25 6.19062 5.52188 4.92188 6.06563C3.65313 6.60938 2.5375 7.3625 1.575 8.325Z"
        fill={fillColor}
      />
    </svg>
  );
};
